import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal, CInputTextArea } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { EditAdminApi, GetSingleAdminApi, AccessLevelApi } from "../../../api";
import { useNavigate, Link, useParams } from "react-router-dom";

export const AdminEdit = () => {
    let params = useParams();
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [accessList, setAccessList] = useState([])


    const onFinishEdit = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await EditAdminApi(formRef, params.id)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت ثبت گردید", { type: "success" })
            navigate('/p/settings/admin');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    const getAccessList = async () => {
        try {
            CtxLoad.setDisplayLoadingBlur(true)
            let res = await AccessLevelApi({ 'page': 1 })
            setAccessList(res.data.groups.data)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    const getDetail = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await GetSingleAdminApi(params.id)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.data.admin) {
            formRef.current['name'].value = res.data.admin.name;
            formRef.current['username'].value = res.data.admin.username;
            formRef.current['group'].value = res.data.admin.group_id;
            formRef.current['status'].checked = res.data.admin.status == 1 ? true : false;
        }
    }


    useEffect(() => {
        document.title = "ایجاد مدیر | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 4, })
        getAccessList()
        getDetail()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش مدیر</h1>

            <form ref={formRef} onSubmit={onFinishEdit} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1">
                                <CInputText name="name" title="نام مدیر" type="text" required={true} />
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CInputText name="username" title="ایمیل" type="text" required={true} deisable={true} />
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-10 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1">
                                <CInputPassword name="password" title="رمز عبور" />
                            </div>
                            {localStorage.getItem('groupAccess') == '-1' &&
                                <div className=" w-[50%] h-full pr-1">
                                    <CSelect name="group" placeholder={'دسترسی'} title="دسترسی" border={true} >
                                        {accessList.map((item: any, index: number) =>
                                            <option key={index} value={item.id}>{item.name}</option>
                                        )}
                                    </CSelect>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px]  pb-[15px] sm:pb-[30px]">
                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-[50%] h-full pl-1 flex items-center">
                                <span className="text-sm mx-2">فعال</span>
                                <div className="flex flex-col justify-center items-center">
                                    <span className="text-[10px]  mb-2 text-center ">وضعیت مدیر</span>
                                    <CToggle name="status" defaultChecked={true} />
                                </div>
                                <span className="text-sm mx-2">غیر فعال</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/admin'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>

        </div>
    )
}
